import * as UserAuthModule from './index';

export const User_ResetPassword = {
  path: '/reset-password',
  name: 'ResetPassword',
  component: UserAuthModule.ResetPassword,
};

export const User_InitiatePasswordReset = {
  path: '/initiate-password-reset',
  name: 'InitiatePasswordReset',
  component: UserAuthModule.InitiatePasswordReset,
};
